import React, { useCallback, useEffect, useMemo } from 'react';
import { Box, CheckBox, ErrorMessage } from '@common-fe/common-fe';

import { LockboxValidationError, lockboxValidationErrorTitle } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const CloseAccountCheckbox = () => {
  const { editableLockbox, setEditableLockbox, validationErrors, originalLockbox, isEditMode } = useLockboxDetailsStore();

  const errorType = useMemo(() => {
    return validationErrors?.find((error) => error === LockboxValidationError.INVESTMENTS_MUST_BE_LIQUIDATED) as LockboxValidationError | undefined;
  }, [validationErrors]);
  
  const errorText = useMemo(() => errorType ? lockboxValidationErrorTitle?.[errorType] : undefined, [errorType]);

  const handleChange = useCallback(() => {
    setEditableLockbox({
      liquidateAllFunds: !editableLockbox?.liquidateAllFunds,
    });
  }, [setEditableLockbox, editableLockbox]);

  useEffect(() => {
    return () => {
      setEditableLockbox({ liquidateAllFunds: false });
    };
  }, [setEditableLockbox]);

  if (isEditMode) {
    return (
      <Box width="294px">
        <CheckBox
          data-testId="liquidate-all-funds-checkbox"
          checked={editableLockbox?.liquidateAllFunds}
          onChange={handleChange}
        />
        {errorText && (
          <Box margin={{ top: 'spacing8' }}>
            <ErrorMessage errorText={errorText} errorStyle={{ fontWeight: 500 }} />
          </Box>
        )}
      </Box>
    );
  }

  return (
    <CheckBox
      data-testId="liquidate-all-funds-checkbox"
      checked={originalLockbox?.liquidateAllFunds}
      disabled
    />
  );
};

export default CloseAccountCheckbox;
